import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductType, CONNECTION_STATE } from 'Types/Product'

import { Product } from 'Features/home/components/EssentialsModules/Product'
import { Card } from '@clickcease/cc-client-components-lib'
import { Globe } from 'Assets/icons/Globe'
import { AdClick } from 'Assets/icons/AdClick'
import { getRiskLevel } from 'Features/home/routes/Home/utils'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { useProductsStatus } from 'Features/MainWrapper/api/getProductsStatus'
import { ProductsWrapper, SmallTitleEssentials } from './EssentialsModules.styled'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'

export const EssentialsModules = ({
  domainsTableRef,
  bmInvalidRate,
  pmInvalidRate,
  pmInvalidPercentage,
  bmInvalidPercentage,
  bmBlocked,
  pmBlocked,
  isLoading,
}: {
  bmInvalidRate: number
  pmInvalidRate: number
  pmInvalidPercentage: number
  bmInvalidPercentage: number
  bmBlocked: number
  pmBlocked: number
  domainsTableRef?: React.RefObject<HTMLDivElement>
  isLoading?: boolean
}) => {
  const { t } = useTranslation('dashboard')
  const { data: packagesLimitsData } = useGetPackagingLimits()
  const { data: productsStatusData } = useProductsStatus()
  const { data: domains } = useGetDomains()

  const bmConnectiomStatus = (() => {
    const bmConnectedWithTag = domains?.data.domains.some((domain) => {
      return (
        domain.botZapping &&
        domain.tagInstalled &&
        !domain.wordpress &&
        !domain.botZappingPluginActivated
      )
    })

    if (bmConnectedWithTag) {
      return CONNECTION_STATE.CONNECTED
    } else {
      return productsStatusData?.botZappingConnectionStage ?? CONNECTION_STATE.NOT_CONNECTED
    }
  })()

  const products: ProductType[] = [
    {
      id: 'paidMarketing',
      title: t('paid_marketing_protection'),
      image: <AdClick height={30} width={30} />,
      blocks: pmBlocked,
      invalidPercentage: pmInvalidPercentage,
      riskLevel: getRiskLevel(pmInvalidRate),
      connected: productsStatusData?.paidMarketingConnectionStage || CONNECTION_STATE.NOT_CONNECTED,
      enabled: packagesLimitsData?.paidMarketingAllowed,
      link: '/paid-marketing/dashboard',
    },
    {
      id: 'botZapping',
      title: 'Bot Mitigation',
      blocks: bmBlocked,
      invalidPercentage: bmInvalidPercentage,
      image: <Globe height={30} width={30} />,
      riskLevel: getRiskLevel(bmInvalidRate),
      enabled: packagesLimitsData?.botZappingAllowed,
      connected: bmConnectiomStatus,
      link: '/botzapping/dashboard',
    },
  ]

  const renderProducts = () => {
    return products.map((product: ProductType) => {
      return (
        <Product
          id={`home-essentials-module-${product.id}`}
          content={product}
          key={'productBlock' + product.id}
          domainsRef={domainsTableRef}
          statusIsLoading={isLoading}
          visitsIsLoading={isLoading}
        />
      )
    })
  }

  return (
    <Card
      id="home-essentials-modules-card"
      title={t('essentials')}
      headerUtilities={<SmallTitleEssentials>{t('show_data')}</SmallTitleEssentials>}
    >
      <ProductsWrapper>{renderProducts()}</ProductsWrapper>
    </Card>
  )
}
